// Reading an API answer without showing the customer a browser's own words.
// Imports nothing, so node --test can run it (api-json.test.mjs).
//
// `response.json()` on an empty or HTML body throws the engine's message:
// Safari says "The string did not match the expected pattern.", Chrome says
// "Unexpected end of JSON input". A 401 (`head :unauthorized`) has an empty
// body, so a guest pressing Apply on a promo code saw Safari's sentence on
// screen (docs/MOBILE_BOOK_DROP_2026-10-07.md, follow-ups). Only text the
// server wrote for people reaches the screen; anything else is logged and
// replaced by a plain sentence.

export class ApiError extends Error {
  constructor (message, { status = null, customer = false, data = null } = {}) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    // the server's `data` beside its sentence (a promo refusal's reason)
    this.data = data
    // true when `message` is the server's own sentence for the customer
    this.customer = customer
  }
}

// The parsed body, or an ApiError that says what came back instead.
export const readJson = response =>
  response.text().then(text => {
    let json = null
    try { json = text ? JSON.parse(text) : null } catch (e) { json = null }
    if (json && typeof json === 'object') return json
    throw new ApiError(`HTTP ${response.status}: ${text ? 'not JSON' : 'empty body'}`, { status: response.status })
  })

// The server's { status: 'error', message } as an error safe to show.
export const serverError = (json, fallback) =>
  new ApiError((json && typeof json.message === 'string' && json.message.trim()) || fallback, { customer: true, data: json?.data || null })

export const TRY_AGAIN = 'Something went wrong on our side. Please try again.'

// What the customer may read for `error`: the server's sentence, or `fallback`.
export const customerMessage = (error, fallback = TRY_AGAIN) =>
  error && error.customer && error.message ? error.message : fallback
